import { OwcTooltip } from "@one/react";
import getRRuleDisplayText from "./transformRRuleToText";
import { getRepetitionIcon } from "../getRepetitionIcon";
import { useSelector } from "react-redux";

export const DateWithRecurrenceCellRenderer = (item: { valueFormatted: string, data: { id: string, repetitionPattern: string, dateFrom: string }}) => {
  const storeUser = useSelector((store: { user: { timezone: string } }) => store.user);
  const displayTimeZone = storeUser.timezone || "UTC";
  const { valueFormatted, data: { id, repetitionPattern } } = item;
  const recurranceText = getRRuleDisplayText(repetitionPattern, new Date(item.data.dateFrom), displayTimeZone);

  return (
    <div id={id} style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
      {valueFormatted}
      {repetitionPattern && (
        <>
          <OwcTooltip anchor={id}>
            <div>
              {valueFormatted}<br />
              {recurranceText}
            </div>
          </OwcTooltip>
          {getRepetitionIcon(recurranceText)}
        </>
      )}
    </div>
  )
}
